var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c(
        "b-col",
        { attrs: { md: "12" } },
        [
          _c(
            "card",
            { staticClass: "stacked-form" },
            [
              _vm.isLoading
                ? _c("l-progress", {
                    staticClass: "mb-2",
                    attrs: {
                      value: 100,
                      height: 20,
                      type: "info",
                      animated: true,
                      striped: true
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "row mb-5" }, [
                _c(
                  "div",
                  { staticClass: "col-md-6" },
                  [
                    _c("fg-input", { attrs: { label: "Nama" } }, [
                      _c("p", [_vm._v(_vm._s(_vm.model.name))])
                    ]),
                    _vm._v(" "),
                    _c("fg-input", { attrs: { label: "Email" } }, [
                      _c("p", [_vm._v(_vm._s(_vm.model.email))])
                    ]),
                    _vm._v(" "),
                    _c("fg-input", { attrs: { label: "Telelpon" } }, [
                      _c("p", [_vm._v(_vm._s(_vm.model.phone))])
                    ]),
                    _vm._v(" "),
                    _c("fg-input", { attrs: { label: "Alamat" } }, [
                      _c("p", [_vm._v(_vm._s(_vm.model.address))])
                    ]),
                    _vm._v(" "),
                    _c("fg-input", { attrs: { label: "Tanggal Dibuat" } }, [
                      _c("p", [_vm._v(_vm._s(_vm.model.createdAt))])
                    ]),
                    _vm._v(" "),
                    _c("fg-input", { attrs: { label: "Dibuat Oleh" } }, [
                      _c("p", [
                        _vm._v(
                          _vm._s(_vm.model.created_by.name) +
                            " (" +
                            _vm._s(_vm.model.created_by.roles[0].name) +
                            ")"
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("fg-input", { attrs: { label: "Diperbarui Oleh" } }, [
                      _c("p", [
                        _vm._v(
                          _vm._s(_vm.model.last_updated_by.name) +
                            " (" +
                            _vm._s(_vm.model.last_updated_by.roles[0].name) +
                            ")"
                        )
                      ])
                    ])
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("edit-button"),
              _vm._v(" "),
              _c("back-button")
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4be7e552", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4be7e552","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Dashboard/Pages/Settings/Suppliers/Show.vue
// module id = Xef6
// module chunks = 4